/**
 * cn — tiny classnames concatenator.
 *
 * Filters out falsy entries and joins the rest with spaces. Lets us
 * write `cn("base", isActive && "active", maybeError)` in JSX without
 * pulling in the full clsx/classnames dependency.
 */
export const cn = (...args: (string | false | null | undefined)[]) =>
  args.filter(Boolean).join(" ");
